import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api";

const UserDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUser = async () => {
        try {
            setLoading(true);

            const response = await api.get(`/user/${id}`);

            if (response.data.status) {
                setUser(response.data.data);
            }
        } catch (error) {
            toast.error(
                error?.response?.data?.message ||
                "Failed to load user details"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUser();
    }, [id]);

    if (loading) {
        return (
            <div className="min-h-screen bg-black flex items-center justify-center">
                <div className="text-[#D4AF37] text-xl">
                    Loading User...
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-black/70 p-4 sm:p-6">

            <div className="max-w-6xl mx-auto">

                {/* Header */}

                <div
                    className="
                        rounded-3xl
                        border
                        border-[#D4AF37]
                        bg-gradient-to-br
                        from-[#2b2110]
                        via-[#17130d]
                        to-[#0d0b08]
                        p-6
                        mb-6
                    "
                >
                    <div className="flex justify-between items-center">

                        <div>
                            <h1 className="text-3xl font-bold text-[#D4AF37]">
                                User Details
                            </h1>

                            <p className="text-[#cdb97a] mt-2">
                                Complete user profile information
                            </p>
                        </div>

                        <button
                            onClick={() => navigate(-1)}
                            className="
                                px-5 py-3
                                rounded-xl
                                border
                                border-[#D4AF37]
                                text-[#D4AF37]
                                hover:bg-[#D4AF37]
                                hover:text-black
                                transition
                            "
                        >
                            Back
                        </button>

                    </div>
                </div>

                {/* Profile Card */}

                <div
                    className="
                        bg-[#17130d]
                        border
                        border-[#6f5517]
                        rounded-3xl
                        p-6
                    "
                >

                    <div className="flex flex-col md:flex-row gap-6">

                        {/* Avatar */}

                        <div className="flex justify-center">

                            <div
                                className="
                                    w-28
                                    h-28
                                    rounded-full
                                    bg-gradient-to-br
                                    from-[#e6c85c]
                                    to-[#8f6910]
                                    flex
                                    items-center
                                    justify-center
                                    text-4xl
                                    font-bold
                                    text-black
                                "
                            >
                                {user?.name?.charAt(0)?.toUpperCase()}
                            </div>

                        </div>

                        {/* User Info */}

                        <div className="flex-1">

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                                <InfoCard
                                    title="Database ID"
                                    value={user?.id}
                                />

                                <InfoCard
                                    title="User ID"
                                    value={user?.user_id}
                                />

                                <InfoCard
                                    title="Name"
                                    value={user?.name}
                                />

                                <InfoCard
                                    title="Email"
                                    value={user?.email}
                                />

                                <InfoCard
                                    title="Phone"
                                    value={user?.phone}
                                />

                                <InfoCard
                                    title="Status"
                                    value={
                                        user?.status === 1
                                            ? "Active"
                                            : "Inactive"
                                    }
                                />

                                <InfoCard
                                    title="House"
                                    value={user?.house}
                                />

                                <InfoCard
                                    title="Street"
                                    value={user?.street}
                                />

                                <InfoCard
                                    title="Landmark"
                                    value={user?.landmark || "N/A"}
                                />

                                <InfoCard
                                    title="City"
                                    value={user?.city}
                                />

                                <InfoCard
                                    title="State"
                                    value={user?.state}
                                />

                                <InfoCard
                                    title="Pincode"
                                    value={user?.pincode}
                                />

                                <InfoCard
                                    title="Created At"
                                    value={
                                        user?.created_at
                                            ? new Date(
                                                  user.created_at
                                              ).toLocaleString("en-IN")
                                            : "N/A"
                                    }
                                />

                                <InfoCard
                                    title="Updated At"
                                    value={
                                        user?.updated_at
                                            ? new Date(
                                                  user.updated_at
                                              ).toLocaleString("en-IN")
                                            : "N/A"
                                    }
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};

const InfoCard = ({ title, value }) => {
    return (
        <div
            className="
                bg-[#0f0d09]
                border
                border-[#4d3c12]
                rounded-xl
                p-4
            "
        >
            <p className="text-xs text-[#a99867] mb-1">
                {title}
            </p>

            <p className="text-[#f1e0a7] font-semibold break-all">
                {value || "N/A"}
            </p>
        </div>
    );
};

export default UserDetails;